import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import UserManagementContent from './SettingsContent';
import useDebounce from '../../../common/components/UseDebounce';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function SettingsContainer({
  match,
  history,
  getSettings,
  settingsList,
  settingsListPager,
  isLoading,
  removeSettings,
  showUserManagement,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Citizen Type',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Citizen Type',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeSettings(data.id, () => {
          getSettings({}, response => {
            const id = _.get(response, 'data.0.id');
            history.push(`/general-settings/citizen-type/${id}`);
            showUserManagement(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   getSettings({ ...formData });
  // };

  useEffect(() => {
    getSettings();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getSettings({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            getData={getSettings}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:userManagementId?`}
            listName="Citizen Type"
            label="Citizen Type List"
            renderItem={item => (
              <div className="px-3 py-3">
                <span> {_.get(item, 'attributes.title')} </span> <br />
                <small className="text-secondary">
                  {_.get(item, 'attributes.description')}
                </small>
              </div>
            )}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={settingsList}
            dataPager={settingsListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <UserManagementContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId && settingsList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(settingsList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  settingsList: PropTypes.instanceOf(Array).isRequired,
  settingsListPager: PropTypes.instanceOf(Object).isRequired,
  removeSettings: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  settingsList: _.get(api, `${c.GET_SETTINGS}.list`) || [],
  settingsListPager: _.get(api, `${c.GET_SETTINGS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_SETTINGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SettingsContainer);
